import DeleteMerchantFromWhitelistDialog from './DeleteMerchantFromWhitelistDialog';

export default DeleteMerchantFromWhitelistDialog;